import { Box, DotStatus } from '@cmg/design-system';

import { ParticipationRecordStatus } from '../../../../../graphql/__generated__';
import {
  participationRecordLinkStatusColors,
  participationRecordLinkStatusLabels,
} from '../../../../../types/domain/participation-sets/constants';
import { ParticipationGridColDef, ParticipationRecordItem } from '../../types';

export type Value = ParticipationRecordItem['statusDisplayName'];

export const linkStatusColDef: ParticipationGridColDef<Value> = {
  field: 'statusDisplayName',
  headerName: 'Link Status',
  filter: 'agMultiColumnFilter',
  floatingFilter: true,
  filterParams: {
    filters: [
      {
        filter: 'agTextColumnFilter',
      },
      {
        filter: 'agSetColumnFilter',
        filterParams: {
          values: Object.values(ParticipationRecordStatus),
          valueFormatter: ({ value }) => participationRecordLinkStatusLabels[value] || value,
        },
      },
    ],
  },
  cellRenderer: ({ value, data }) => {
    return data?.status ? (
      <Box height="inherit" display="flex" flexDirection="column" justifyContent="center">
        <DotStatus
          aria-label={value}
          color={participationRecordLinkStatusColors[data.status]}
          label={value}
          variant="filled"
        />
      </Box>
    ) : null;
  },
};
